import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export const useDeleteReservationCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (categoryId: string) => {
      // Get the current user and verify permissions
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        throw new Error("Usuario no autenticado");
      }

      console.log('[useDeleteReservationCategory] Soft deleting category:', categoryId);

      // Soft delete: set is_active to false instead of actually deleting
      const { data, error } = await supabase
        .from('reservation_categories')
        .update({ 
          is_active: false,
          updated_at: new Date().toISOString()
        })
        .eq('id', categoryId)
        .select('*')
        .single();

      if (error) {
        console.error('[useDeleteReservationCategory] Error:', error);
        throw error;
      }

      console.log('[useDeleteReservationCategory] Category deactivated successfully:', data);
      return data;
    },
    onSuccess: (category) => {
      console.log('[useDeleteReservationCategory] Cache invalidation for gym:', category.gym_id);
      
      // Invalidate with exact query key that useReservationCategories uses
      queryClient.invalidateQueries({ 
        queryKey: ['reservation-categories', category.gym_id] 
      });
      
      // Also invalidate any queries that might use different gymId patterns
      queryClient.invalidateQueries({ 
        predicate: (query) => {
          return query.queryKey[0] === 'reservation-categories';
        }
      });
      
      toast.success("Categoría eliminada exitosamente");
    },
    onError: (error) => {
      console.error('[useDeleteReservationCategory] Mutation error:', error);
      toast.error("Error al eliminar la categoría: " + error.message);
    },
  });
};